<template>
	<div>
		<p class="tit" v-if="states != 1">聊天记录</p>

		<div class="group" v-if="states != 1">
			<el-button  class="left" icon="el-icon-arrow-left" @click="moveLeft()"></el-button>
			<ul ref="ulWrap">
				<li v-for="item in userList" @click="getDialog(item)" :class="groupId==item.id?'select':''">{{item.realName}}</li>
			</ul>
			<el-button class="right" icon="el-icon-arrow-right" @click="moveRight()"></el-button>
		</div>

		 <el-table  :data="tableData" border>
			<el-table-column  prop="sender" label="发送人" width="220" align="center">
			</el-table-column>
			<el-table-column  prop="sendTime"  label="发送时间"  width="260" align="center">
			</el-table-column>
			<el-table-column  label="发送内容" align="center">
				<template slot-scope="scope">
					<p v-if="scope.row.type==1">{{scope.row.sendContent}}</p>
					<img v-if="scope.row.type==2" :src="scope.row.sendContent" />
					<div class="voice" v-if="scope.row.type==3">
						<audio ref=audioBox :src="scope.row.sendContent" controls="controls" hidden="hidden">不支持</audio>
						<div class="voiceBox"  @click="startPlay(scope.row)" >
							<img class="img" src="./img/voicet.png" alt="" />
							<span>{{scope.row.time}} s</span>
							<img v-show="scope.row.gifShow" class="gif" src="./img/gif.gif" alt="" />
						</div>
					</div>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
	import { getChatRecordGroup,getChatRecordSingle,getCaseConnectedIMGroups } from "@/views/axios/api.js"
	export default {
	  data() {
	    return {
			tableData:[{
				sender:"aaa",
				sendTime:'2019-8-3',
				type:'1',
				sendContent:'wenziwenzi'
			},
			{
				sender:"aaa",
				sendTime:'2019-8-3',
				type:'2',
				sendContent:'http://api.dev.dajiuxing.com.cn/p3/a/2019/0523/1020/40bad644_96f083bf04a196_0.png'
			},
			{
				sender:"aaa",
				sendTime:'2019-8-3',
				type:'3',
				time:'3',
				gifShow:false,
				sendContent:'http://api.dev.dajiuxing.com.cn/a3/a/2019/0509/0939/fc1131dc_92a225788b25a1_src.amr.mp3'
			},
			{
				sender:"aaa",
				sendTime:'2019-8-3',
				type:'3',
				time:'3',
				gifShow:false,
				sendContent:'http://api.dev.dajiuxing.com.cn/a3/a/2019/0509/0939/fc1131dc_92a225788b25a1_src.amr.mp3'
			}
			],
			caseid:'',
			userList:[],
			groupId:''
	    }
	  },
	  props:[
		'states'
	  ],
	  methods: {
	    onSubmit() {
	      console.log('submit!');
	    },
		startPlay(row){
			this.$refs.audioBox.play();
			row.gifShow=true;
			setTimeout(()=>{
				row.gifShow=false;
			},row.time * 1000)
		},
		getDialog(item){
			// this.groupId=item.id
			var data={
				groupId:'group-rescue-'+this.caseid,
				caseId:this.caseid,
				start:0,
				count:1000,
				token:JSON.parse(window.localStorage.getItem("data")).data,
			}
			getChatRecordGroup(data)
			.then( res =>{
				console.log(res.data)
			})
			.catch( err =>{
				console.log(err)
			})

		},
		getUserList(){
			var data={
				caseId:this.caseid,
				token:JSON.parse(window.localStorage.getItem("data")).data,
			}
			getCaseConnectedIMGroups(data)
			.then(res =>{
				this.userList=res.data.obj[0].users
			})
			.catch( err =>{
				console.log(err)
			})
		},
		moveLeft(){
			var left=this.$refs.ulWrap.style.left
			if(left){
			  	left=parseInt(left)
			}else{
				left=0
			}
			left -= 100;
			this.$refs.ulWrap.style.left=left+"px"
		},
		moveRight(){
			var left=this.$refs.ulWrap.style.left
			if(left){
			  	left=parseInt(left)
			}else{
				left=0
			}
			left += 100;
			this.$refs.ulWrap.style.left=left+"px"


		}
	  },
	  mounted(){
	  	this.caseid=this.$route.query.caseid;
		console.log(this.caseid)
		// this.getUserList();
    this.getDialog()
	  }
	}
</script>

<style scoped>
	.tit{
		font-size: 22px;
		color: #333;
		width: 100%;
		text-align: center;
		margin-top: 70px;
		margin-bottom: 40px;
	}
	.voice{height: 40px;overflow: hidden;margin: 0 auto;width: 170px;}
	.voiceBox{overflow: hidden;position: relative;}
	.voiceBox .gif{position: absolute;top: 11px;left: 15px;}
	.voiceBox .img{float: left;cursor: pointer;}
	.voiceBox span{float: left;margin-top: 10px;margin-left: 10px;}
	.voiceBox1{float: right;position: relative;}
	.voiceBox1 span{float: left;margin-top: 14px;margin-right: 10px;}
	.voiceBox1 .gif{position: absolute;top: 11px;right: 16px;}
	.group{
		text-align: center;
		width: 100%;
		margin: 0 auto;
		position: relative;
		height: 30px;
		margin-bottom: 30px;
	}
	.group ul{
		display: inline-block;
		width: calc(100% - 200px);
		height: 30px;
		overflow: hidden;
		position: absolute;
		top: 0;
		left: 55px;
	}
	.group ul li{
		float: left;
		height: 30px;
		line-height: 30px;
		padding: 0 5px;
	    cursor: pointer;
		background: #00ABFA;
		margin-right: 10px;
		color: #fff;
	}
	.el-button{
		border: 0;
		position: absolute;
		z-index: 999;
		background: #fff;
	}
	.left{
		left: 0;
	}
	.right{
		right: 0;
	}
	.group li.select{
		background: #fff;
		color: #00ABFA;
	}
</style>



// WEBPACK FOOTER //
// src/views/cmd_center/chatRecord.vue